import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 2l5 5 5-5M4 9l5 5 5-5" stroke="currentColor" stroke-width=".5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export { symbol as default };
